import List from "./list";
import Edit from "./edit";

const TopicsRoutes = { List, Edit };

export default TopicsRoutes;
